<!-- navigation -->
<div class="border-bottom p-1">
  <div class="row">
    <div class="col-2">
      <app-button text="{{'LEFT'|translate}}" icon="chevron-left" hideText="true" (click)="prevWeek()"></app-button>
    </div>
    <div class="col-8 text-center">
      <h5 class="m-0" style="line-height: 2.375rem">{{'WEEK'|translate}} {{currentDateString}}</h5>
    </div>
    <div class="col-2 text-right">
      <app-button text="{{'RIGHT'|translate}}" icon="chevron-right" hideText="true" (click)="nextWeek()"></app-button>
    </div>
  </div>
</div>

<!-- loading spinner -->
<div *ngIf="isLoading" class="text-center m-3">
  <app-spinner size="l" dark="true"></app-spinner>
  <p>{{'LOADING'|translate}}</p>
</div>

<!-- desktop view -->
<table *ngIf="!isLoading" class="room-schedule-table table table-sm table-bordered table-striped d-none d-sm-table">

  <thead>
    <tr>
      <th></th>
      <th [class.sat]="i===5" *ngFor="let h of tableModel.headers; let i=index">{{h.date|eventoDayShort}}
        {{h.date.getDate()}}</th>
    </tr>
  </thead>

  <tbody>
    <tr *ngFor="let wh of tableModel.weekHours">
      <td>{{formatTime(wh.hour)}}</td>
      <ng-container *ngFor="let h of wh.hours; let i=index">
        <td [class.sat]="i===5">

          <ng-container *ngFor="let o of h.scheduleItems">
            <app-room-schedule-item [scheduleItem]="o" [fromHour]="fromHour" [toHour]="toHour"
              (createReservation)="onCreateReservation($event)"></app-room-schedule-item>
          </ng-container>

        </td>
      </ng-container>
    </tr>
  </tbody>

</table>

<!-- mobile view -->
<!-- <ng-container *ngFor="let m of mobileTableData; let i = index"> -->
<div class="d-block d-sm-none">
  <ng-container *ngFor="let item of items; let i = index">
    <app-room-allocation-mobile [item]="item" [baseDate]="currentDate" [type]="type"
      (createReservation)="onCreateReservation($event)" [bgLight]="showBgLight(i)" hideInfoButton="true"
      hideCalendarButton="true">
    </app-room-allocation-mobile>
  </ng-container>
</div>